import { render, staticRenderFns } from "./WelcomePlatform.vue?vue&type=template&id=5260e453&scoped=true&"
import script from "./WelcomePlatform.vue?vue&type=script&lang=js&"
export * from "./WelcomePlatform.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePlatform.vue?vue&type=style&index=0&id=5260e453&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5260e453",
  null
  
)

export default component.exports